import { ChangeDetectionStrategy, Component, ViewContainerRef, inject } from '@angular/core';
import { APP_VERSION } from '@shared/constants/platform/app-version.token';
import { ENVIRONMENT } from '@shared/constants/platform/environment.token';
import { Environment, EnvironmentName } from '@shared/models/platform/environment.models';

@Component({
  selector: 'fb-version-renderer',
  templateUrl: './version-renderer.component.html',
  styleUrls: ['./version-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionRendererComponent {
  private readonly viewContainerRef = inject(ViewContainerRef);
  protected readonly appVersion = inject(APP_VERSION);

  constructor() {
    const environment = inject<Environment>(ENVIRONMENT);

    if (environment.name === EnvironmentName.PROD) {
      this.viewContainerRef.clear();
    }
  }
}
